import { render, staticRenderFns } from "./ClubInfoModal.vue?vue&type=template&id=388a129a&"
import script from "./ClubInfoModal.vue?vue&type=script&lang=js&"
export * from "./ClubInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388a129a')) {
      api.createRecord('388a129a', component.options)
    } else {
      api.reload('388a129a', component.options)
    }
    module.hot.accept("./ClubInfoModal.vue?vue&type=template&id=388a129a&", function () {
      api.rerender('388a129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/mobile/ClubInfoModal.vue"
export default component.exports